export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/number.js
// module id = Mz1A
// module chunks = 0